'use strict';

var SoaModel = require('bunsen/models/SoaModel');
var PaymentMethod = SoaModel.extend();
module.exports = PaymentMethod;

var _ = require('underscore');
var paymentMethodTypes = {
    'WIRE_TRANSFER': 'WireTransfer',
    'CHECK': 'Check',
    'CREDIT_TO_USER_ACCOUNT': 'CreditToUserAccount',
    'DISCOUNT': 'Discount',
    'DIRECT_PAYMENT': 'DirectPayment',
    'CASH': 'Cash',
    'ACH': 'ACH',
    'NOT_AVAILABLE': 'NotAvailable',
    'PAYPAL_ACCOUNT': 'PayPalAccount',
    'CREDIT_CARD'   : 'CreditCard',
    'APPLE_PAY'     : 'ApplePay'
};

var isPaymentMethodType = function (type) {
    return this.get('paymentMethodType') === type;
};

// Service enums for card types
_.extend(PaymentMethod, {
    CARD_TYPE_VISA      : 'Visa',
    CARD_TYPE_MASTER    : 'MasterCard',
    CARD_TYPE_DISCOVER  : 'Discover',
    CARD_TYPE_AMEX      : 'American Express'
});

/**
 * @class PaymentMethod
 * @extends SoaModel
 * @property {string} idAttribute - "id"
 * @property {array} relations
 *      @property relations.type {Backbone.One}
 *      @property relations.key {string}- "item"
 *      @property relations.relatedModel {Backbone.Model}
 *      @property relations.collectionType {Backbone.Models}
 */
_.extend(PaymentMethod.prototype, {
    defaults : {
        apiType : 'defaultPaymentMethod'//This maps to a java interface
        // so, do a concrete version, and define apiType
        //`defaultPaymentMethod` is the placeholder for now, until we do actual concrete implementations
    }
});

_.each(paymentMethodTypes, function (description, type) {
    PaymentMethod['TYPE_' + type] = type;
    PaymentMethod.prototype['is' + description] = _.partial(isPaymentMethodType, type);
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/PaymentMethodModel.js
// module id = 11
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54